// src/services/userService.js
import { apiFetch } from "../utils/api";

export const getUsers = async () => {
  const res = await apiFetch("/api/users");
  if (!res.ok) throw new Error("Failed to fetch users");
  return res.json();
};

export const createUser = (data) =>
  apiFetch("/api/users", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });

export const updateUser = (username, data) =>
  apiFetch(`/api/users/${username}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });

export const deleteUser = (username) =>
  apiFetch(`/api/users/${username}`, { method: "DELETE" });

export const assignDevices = (username, ids) =>
  apiFetch(`/api/users/${username}/devices/assign`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ ids }),
  });

export const assignEmissionPoints = (username, ids) =>
  apiFetch(`/api/users/${username}/emission-points/assign`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ ids }),
  });

export const fetchLinkedDevices = (username) =>
  apiFetch(`/api/users/${username}/devices?linked=true`).then((res) => res.json());

export const fetchUnlinkedDevices = (username) =>
  apiFetch(`/api/users/${username}/devices?linked=false`).then((res) => res.json());

export const fetchLinkedEmissionPoints = (username) =>
  apiFetch(`/api/users/${username}/emission-points?linked=true`).then((res) => res.json());

export const fetchUnlinkedEmissionPoints = (username) =>
  apiFetch(`/api/users/${username}/emission-points?linked=false`).then((res) => res.json());
